import {
    TOOL_BONUS_CARD_CONTEXT,
    TOOL_BONUS_CARD_STEPS
} from "@omni/services/tracking/trackers/tools/bonusCard/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";
import { createUserId } from "@omni/services/tracking/trackers/utils";
import { StepVariables } from "@omni/types/components/tracking/tracking-info/tools/toolStep.trackingInfo";

export const trackStart = () => {
    ToolsStepTracker.track(
        TOOL_BONUS_CARD_STEPS.start,
        TOOL_BONUS_CARD_CONTEXT
    );
};

type TrackBonusCardAddedData = {
    email: string;
    storeId?: string;
    optInBirthdayCard: boolean;
};

export const trackSubmit = (bonusCardResults?: TrackBonusCardAddedData) => {
    if (!bonusCardResults) return;

    const customerId = createUserId(bonusCardResults.email);

    const step: StepVariables = {
        ...TOOL_BONUS_CARD_STEPS.submit,
        result: {
            customerid: customerId,
            storeId: bonusCardResults.storeId,
            birthdayoptin: !!bonusCardResults.optInBirthdayCard
        }
    };

    ToolsStepTracker.trackSubmit(step, TOOL_BONUS_CARD_CONTEXT);
};
